export const WEBSITE_URL =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
    ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
    : process.env.NEXT_PUBLIC_WEBSITE_URL!

if (!WEBSITE_URL) throw new Error('Missing WEBSITE_URL')
